function AWANotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <img src="/gearbelt-small.svg" alt="Gearbelt Logo" className="mb-2 h-12" />
      <h1 className="text-2xl font-bold">Page not found</h1>
    </div>
  );
}

export default AWANotFoundPage;
